import { takeEvery } from 'redux-saga/effects';
import { load } from 'sdk/billernet';
import { LOAD } from 'model/billernet';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({ api: load, dataName: ORM, type: LOAD })
  );
}
